export default __webpack_public_path__ + "locales/pt/DeleteDialog.json?hash=e09d0435ff6aac136bbae37d3de2e558";